module.exports = __webpack_public_path__ + "static/media/womens-health-services.42583141.jpg";